/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSpotAuditSpotMediaListQueryResponse, AuditSpotAuditSpotMediaListQueryParams } from "../models/AuditSpotAuditSpotMediaList";

export function getAuditSpotAuditSpotMediaListUrl() {
  const res = { method: 'GET', url: `/audit-spot/v1/media` as const }
  return res
}

/**
 * @description Returns paginated media using the mi-api CRUD list contract. Filterable fields: `customId`, `title`, `status`, `createdAt`, `md5`.
 * @summary List media
 * {@link /audit-spot/v1/media}
 */
export async function auditSpotAuditSpotMediaList(params: AuditSpotAuditSpotMediaListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditSpotAuditSpotMediaListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditSpotAuditSpotMediaListUrl().url.toString(), params, ... requestConfig })
  return res.data
}